
import delay from 'lodash/delay'
import forEach from 'lodash/forEach';
import YouTubePlayer from 'youtube-player';
import general from './general';
import verge from 'verge';

let rtn = {};

const 
		videoElementCollection = document.querySelectorAll('.video-container[data-type]'),
		youtubeTemplate = document.createElement('div'),
		nativetemplate = document.createElement('video'),
		posterTemplate = document.createElement('div'),
		playButton = document.createElement('button'),
		caption = document.createElement('figcaption');



/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param e [description]
 * @param y [description]
 * 
 * @return [description]
 */
const createYoutubeTemplate = (container) => {

	const 
		id = container.dataset.id,
		yt = youtubeTemplate.cloneNode(true),
		play = playButton.cloneNode(true),
		poster = container.dataset.poster,
		vid = YouTubePlayer(yt, {
			videoId: id,
			allowfullscreen: 'true',
				playerVars: {
            	controls: 1,
            	showinfo: 0,
            	wmode: 'opaque',
            	autoplay: 0,
            	modestbranding: 1,
            	fs: 1,
            	rel: 0
        	}
		}),
		ps = posterTemplate.cloneNode(true),
		playEvent = (e) => {
			e.preventDefault();
			container.classList.add('play');
			vid.loadVideoById(id);
		};

	//vid.loadVideoById(id);

	ps.classList.add('poster');

	if (poster) {
		ps.style.backgroundImage = 'url(' + poster + ')';
	}
	ps.appendChild(play);

	play.classList.add('play');
	play.innerHTML = 'play_arrow';
	play.addEventListener('click', playEvent, false);

	return {'yt' : yt, 'ps' : ps};
}


/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param d [description]
 * @param r [description]
 * 
 * @return [description]
 */
const createNativeTemplate = (container) => {

	const id = container.dataset.id,
		  poster = container.dataset.poster,
		  video = nativetemplate.cloneNode(true),
		  play = playButton.cloneNode(true),
		  autostart = container.dataset.autostart,
		  buffer = -Math.abs(general.getBreakpoint()['height'] / 4),
		  scrollEventHandler = (e={}) => {
		  	if (verge.inY(video, buffer)) {
		  		video.play();
		  	} else {
		  		video.pause();
		  	}
		  }

		  general.addClass(video, 'video');
		  video.setAttribute('controls', 'true');
		  video.setAttribute('poster', poster);

		  video.src = id;
		  container.appendChild(video);

		  //check to see if video is in viewport to play or not
		  /*if (autostart) {
		  	window.addEventListener('scroll', scrollEventHandler, false);
		  	scrollEventHandler();
		  }*/
		  

}


rtn.init = () => {

	if (videoElementCollection.length > 0) {

		forEach(videoElementCollection, (container) => {

			let video = null,
				cap = caption.cloneNode(true);

			switch(container.dataset.type) {

				case 'youtube':
				video = createYoutubeTemplate(container);
				cap.innerHTML = container.dataset.title;
				container.appendChild(video.yt);
				container.appendChild(video.ps);
				container.appendChild(cap);
				break;


				case 'native':
				video = createNativeTemplate(container);
				cap.innerHTML = container.dataset.title;
				break;

			}	
		})
	}
}



module.exports = rtn;


// WEBPACK FOOTER //
// ./js/service/video-player.js